import common from './common'

const newsletter = {
  ...common.button,
  color: `white`,
  width: `100%`,
  bg: `alpha`,
  mb: 3,
  ':hover': {
    color: `omegaLighter`,
    bg: `omegaDark`,
    borderColor: `omegaDark`
  }
}

export default newsletter